import * as React from 'react';
import { routeConstants } from 'app/routes/route-constants';
import { SearchTile, TileLink } from 'app/components/search-tile';
import { SearchTileProps } from '../search-container/types';
import { TileInfo } from '../search-tile';
import { PersonMeatballMenu } from 'app/area/administration/list/components/person-meatball-menu';
import { ids } from 'app/area/administration/constants';
import { Tag } from 'app/components/tag';
import styles from './role-tile.scss';
import { DefaultRole } from 'app/area/administration/shared/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { DefaultRoleMeatballItem } from 'app/area/administration/list/roles/default-role-meatball-item';

export const RoleTile: React.FC<SearchTileProps> = props => {

  const { data, itemPersonAccess, canDuplicate, onDelete, onLoadPersonAccess, onClearPersonAccess, translation, setDefaultRole,
    settingDefaultRoleId, showMeatball, defaultRole } = props;

  const setAsDefault = () => setDefaultRole({ value: data.id });

  const removeDefault = () => setDefaultRole({} as DefaultRole);

  return <SearchTile
    componentId={ids.search.tile}
    footer={<TileInfo id={data.id} personId={data.personId} />}
    deleted={data.deleted}>
    {showMeatball && <PersonMeatballMenu
      id={data.id}
      canDuplicate={canDuplicate}
      itemPersonAccess={itemPersonAccess}
      labelDeleteTitle={translation.delete_role}
      labelDelete={translation.delete_role}
      labelCancel={translation.cancel}
      labelDescription={translation.delete_role_desc}
      labelNoAccess={translation.no_access_has_been_granted}
      labelDuplicate={translation.duplicate_role}
      onDuplicate={routeConstants.roleDuplicateFor}
      onDelete={onDelete}
      onLoadPersonAccess={onLoadPersonAccess}
      onClearPersonAccess={onClearPersonAccess}>

      <li>
        {data.isDefault
          ? <DefaultRoleMeatballItem onClick={removeDefault} label={translation.remove_default_role} roleName={data.name} />
          : <DefaultRoleMeatballItem onClick={setAsDefault} label={translation.set_as_default_role} roleName={data.name}
            defaultRole={defaultRole} translation={translation} />}
      </li>
    </PersonMeatballMenu>}

    <div className={styles.content}>
      <div className={styles.leftSide}>
        <TileLink
          url={routeConstants.roleEditFor(data.id)}
          title={data.name} />
        {isDefinedIncludingZero(settingDefaultRoleId) && data.id === settingDefaultRoleId ? <div>
          <div className={styles.spinLoader} />
        </div> : null}
      </div>
      {data.isDefault ? <div>
        <Tag className={styles.tag}>{translation.default}</Tag>
      </div> : null}

    </div>
  </SearchTile>;
};
